import { useMemo, useState } from "react"
import { useField, useFormikContext } from "formik"
import { FormHelperText, Stack } from "@mui/material"

import { attendeeInitValues } from "../../../../dialogs/createUpdateBookingDialog/attendees/attendeesForm/CreateUpdateAttendeesForm"
import { AttendeeDetails } from "../../../../dialogs/createUpdateBookingDialog/attendees/attendeesForm/attendeesTypes"
import { useAppLocalization } from "../../../../../../modules/localization/components/AppLocalizationProvider"
import { CreateOrderDialogParticipants } from "./CreateOrderDialogParticipants"
import { MeetingServiceConfig, DynamicConfigKey, MeetingServiceTabValues } from "../../form/formTypes"
import { StandardButton } from "../../../../buttons/StandardButton"
import { findGroupByFieldKey, getFormikFieldError } from "../../form/helpers"

const KEY = DynamicConfigKey.REGISTER_PARTICIPANTS

type ParticipantsProps = Readonly<{
    meetingServiceConfiguration: MeetingServiceConfig
}>

export function Participants({ meetingServiceConfiguration }: ParticipantsProps) {
    const { l10n } = useAppLocalization()
    const [{ value }, meta, participantsHelpers] = useField<AttendeeDetails[]>(KEY)
    const { submitCount } = useFormikContext<MeetingServiceTabValues>()

    const participants: AttendeeDetails[] = value || []

    const [opeParticipantsDialog, setOpenParticipantsDialog] = useState<boolean>(false)

    const handleOpenParticipantsDialog = () => {
        participants.length === 0 && participantsHelpers.setValue([attendeeInitValues])
        setOpenParticipantsDialog(true)
    }
    const handleCloseParticipantsDialog = () => {
        if (participants.length === 1 && JSON.stringify(participants[0]) === JSON.stringify(attendeeInitValues))
            participantsHelpers.setValue([])

        setOpenParticipantsDialog(false)
    }
    const handleChangeParticipants = (val: AttendeeDetails[]) => {
        participantsHelpers.setValue(val)
        setOpenParticipantsDialog(false)
    }

    const participantsSection = useMemo(
        () => findGroupByFieldKey(meetingServiceConfiguration.sections, KEY),
        [meetingServiceConfiguration],
    )

    const participantsField = participantsSection?.fields.find((el) => el.key === KEY)

    const fields = participantsField?.inputField?.fields

    const { helperText } = getFormikFieldError(meta, submitCount)

    return (
        <Stack gap="0.25rem" alignItems="flex-start">
            <StandardButton
                type="button"
                color="blue"
                variant="outlined"
                size="small"
                onClick={handleOpenParticipantsDialog}
            >
                {!!participants.length
                    ? l10n.getString("create-order-participants-edit-button")
                    : participantsField?.label}
            </StandardButton>

            {helperText && <FormHelperText error>{helperText}</FormHelperText>}

            {participantsSection && opeParticipantsDialog && (
                <CreateOrderDialogParticipants
                    open={opeParticipantsDialog}
                    onClose={handleCloseParticipantsDialog}
                    fieldsParams={fields}
                    participantsList={participants}
                    handleChangeParticipants={handleChangeParticipants}
                />
            )}
        </Stack>
    )
}
